module.exports = __webpack_public_path__ + "dafc2d455b6de791017acfb2001f666d.png";